app.service("StaffCustomerService", ['$rootScope', function ($rootScope) {

    const modelConstructor = $rootScope.model_constructor;

    const StaffCustomerModel = modelConstructor.extend(modelConstructor.BasicModel, {
        name: "Staff Customer",
        id: "staff_customer",
        request_in_progress: false,
        requestCallbacks: [],
        requestCustomers: requestCustomers

    });

    this.model = new StaffCustomerModel();

    function requestCustomers(callback) {
        const model = this.root;
        if (callback) {
            model.requestCallbacks.push(callback);
        }
        if (model.request_in_progress) {
            return
        }
        model.request_in_progress = true;
        const endpoint = '/request/api.php/customers?fields=customer_code,name,contact,telephone,email,postcode,active';
        $rootScope.service.request.getRequest(endpoint, function (success, data, messages) {
            model.request_in_progress = false;
            let i;
            if (success) {
                model.choice_order.length = 0;
                for (i = 0; i < data.length; i++) {
                    const customer = data[i];
                    const customerCode = customer.customer_code;
                    model.choice_order.push(customerCode)
                    model.choices[customerCode] = customer;
                }
            }
            const choiceList = model.choiceList();
            for (i = 0; i < model.requestCallbacks.length; i++) {
                model.requestCallbacks[i](success, choiceList, messages);
            }
            model.requestCallbacks.length = 0;
        })
    }

}]);